<template>
  <div class="container">
    <Search></Search>
    <TabBar></TabBar>
    <BannerList></BannerList>
    <!-- <GoodKind :allInfomation="allInfomation"></GoodKind> -->
    <!-- 秒杀 -->
    <!-- <Spike/> -->
    <!-- 拼团和砍价 -->
    <!-- <div class="activities-box">
      <div class="activities">
        <Fight />
      </div>
      <div class="activities">
        <Bargain />
      </div>
    </div> -->
    <!-- 商品显示区域 -->
    <div class="content">
      <!-- 药品列表 -->
      <div class="item-class">
        <div class="item-class-head">
          <span class="one">1</span>
          <span class="one two">F</span>
          <span class="item-class-title">精品推荐</span>
        </div>
        <div class="detail-project">
          <div class="banner-img">
            <img src="../../assets/pc/images/index/index-banner2.png" alt="" />
          </div>
          <div
            class="item"
            v-for="item of contentList"
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <div class="head">
              <img v-lazy="item.image" alt="" />
            </div>
            <div class="bottom">
              <div class="title">{{ item.store_name }}</div>
              <div class="attr-content">
                <div class="price">￥{{ item.price }}</div>
                <div class="sale">库存: {{ item.stock }}件</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="limit-banner">
      <img src="../../assets/pc/images/index/banner-bg.png" alt="" />
    </div>
    <AuthModel :modelAuth="modelAuth"></AuthModel>
    <ThreeModel ref="modalThreeChild"></ThreeModel>
  </div>
</template>

<script>
import Search from "@/components/pc/Search";
import TabBar from "@/components/pc/nav/TabBar";
import BannerList from "@/components/pc/nav/BannerList";
// import GoodKind from "@/components/pc/activities/GoodKind";
// import Spike from '@/components/pc/activities/Spike'
// import Fight from "@/components/pc/activities/Fight";
// import Bargain from "@/components/pc/activities/Bargain";
import AuthModel from "@/components/pc/authenticate/AuthModel";
import ThreeModel from "@/components/pc/authenticate/ThreeModel";
import { getUserInfo } from "@api/user";
import { mapActions } from "vuex";
import { getIndex } from "@api/public";
export default {
  name: "Index",
  created() {
    getIndex().then(res => {
      this.bannerList = res.data.banner;
      this.bastList = res.data.info.bastList.product;
      this.logoURL = res.data.logoURL;
      this.allInfomation = res.data;
    });
  },
  data() {
    return {
      userInfo: {},
      setIntervalObj: null,
      bannerList: [],
      bastList: [],
      modelAuth: false, // 资质认证弹窗
      allInfomation: {}, // 首页所有信息
      logoURL: ""
    };
  },
  computed: {
    contentList() {
      let arr = [];
      if (this.allInfomation && Object.keys(this.allInfomation).length > 0) {
        this.allInfomation.info.bastList.product.forEach((element, index) => {
          if (index < 3) {
            arr.push(element);
          }
        });
      }
      return arr;
    }
  },
  methods: {
    ...mapActions(["IS_LOGIN"]),
    async goDetail(id) {
      const isLogin = await this.IS_LOGIN();
      if (isLogin) {
        const userinfomation = await getUserInfo();
        this.userInfo = userinfomation.data;
        if (this.userInfo.is_certification === 0) {
          this.modelAuth = true;
        } else if (this.userInfo.is_certification === 1) {
          this.$router.push("/goodsDetail/" + id);
        } else if (this.userInfo.is_certification === 2) {
          this.$Modal.info({ content: "您的资质认证正在审核中" });
        } else {
          this.$refs.modalThreeChild.newValue = true;
        }
      } else {
        this.$router.push("/login");
      }
    },
    changeShowAuth() {
      this.modelAuth = false;
    }
  },
  components: {
    Search,
    AuthModel,
    ThreeModel,
    // Spike,
    // Fight,
    // Bargain,
    TabBar,
    BannerList
    // GoodKind
  }
};
</script>

<style lang="stylus" scoped>
.container
  background-color #f8f8f8
  .activities-box
    width 1020px
    margin 0px auto
    display flex
    justify-content space-between
   .activities
      width 49%
      height 300px
      padding 10px 20px
      background #fff
      margin-top 20px
  .limit-banner
    width 1200px
    height 120px
    margin 0 auto

  .content
    width 1200px
    margin 0px auto
    .item-class
      width 100%
      margin-top 20px
      .item-class-head
        width 100%
        height 60px
        border-bottom 2px solid #0e86ff
        .one
          background #0e86ff
          display inline-block
          width 28px
          height 28px
          border-radius 14px 0 0 14px
          transform translateY(-3px)
          color #fff
          text-align center
          line-height 28px
          font-size 16px
        .two
          border-radius 0 14px 14px 0
          margin-left 2px
        .item-class-title
          font-family 'Microsoft yahei'
          font-size 24px
          line-height 60px
          color #333
          margin-left 16px
      .detail-project
        display flex
        flex-wrap wrap
        margin-bottom 30px
        .banner-img
          margin-top 15px
          margin-right 15px
          width 471px
          img
            width 100%
            height 100%
        .item
          background #fff
          width: calc(calc((100% - 60px) / 5));
          margin-right 15px
          margin-top 15px
          padding 15px
          &:hover
            cursor pointer
          &:nth-child(4)
            margin-right 0
          .head
            width 200px
            height 200px
            text-align center
            margin 0 auto 10px
            img
              width 100%
              height 100%
          .bottom
            padding 5px 5px 0
            .title
              font-size 13px
              font-family 'Arial'
              color 333
              overflow hidden
              text-overflow ellipsis
              white-space nowrap
              height 26px
            .attr-content
              display flex
              justify-content space-between
              color #999
              .price
                color #ff5c4d
                font-size 16px
                font-family 'Microsoft yahei'
              .sale
                line-height 26px
                font-size 12px
</style>
